import { Draggable } from "@hello-pangea/dnd";
import { Paper, Stack, Typography } from "@mui/material";

interface DraggableIngredientProps {
    id: string;
    index: number;
    title?: React.ReactNode;
    subTitle?: React.ReactNode;
    color?: string;
}

export default function DraggableIngredient({ id, index, title, subTitle, color }: DraggableIngredientProps) {
    let innerContent: React.ReactNode;
    if (title || subTitle) {
        innerContent = (
            <>
                <Typography>{title}</Typography>
                <Typography variant="subtitle2">{subTitle}</Typography>
            </>
        );
    } else {
        innerContent = <></>;
    }

    return (
        <Draggable draggableId={id} index={index}>
            {(provided, snapshot) => (
                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                    <Paper
                        style={{
                            backgroundColor: color,
                            marginLeft: "15px",
                            marginTop: "7.5px",
                            marginBottom: "7.5px",
                        }}
                    >
                        <Stack
                            paddingLeft="15px"
                            paddingRight="15px"
                            paddingTop="5px"
                            paddingBottom="5px"
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            {innerContent}
                        </Stack>
                    </Paper>
                </div>
            )}
        </Draggable>
    );
}
